import { gql } from '@apollo/client';

export const ContentCardFragment = gql`
  fragment ContentCardFragment on ContentCard {
    ... on ContentCard {
      backgroundColor
      ctas {
        id
        ctaStyle
        displayLinked
        showIcon
        text
        title
        url
      }
      customBackgroundColor
      eyebrow
      header
      horizontalTextAlignment
      internalSpace {
        mobile
        tablet
        desktop
      }
      icon {
        file {
          details {
            image {
              height
              width
            }
          }
          fileName
          url
        }
        id
        title
      }
      id
      image {
        description
        file {
          contentType
          details {
            image {
              height
              width
            }
            size
          }
          fileName
          url
        }
        id
        title
      }
      desktopImage {
        description
        file {
          details {
            image {
              height
              width
            }
          }
          url
        }
      }
      tabletImage {
        description
        file {
          details {
            image {
              height
              width
            }
          }
          url
        }
      }
      mobileImage {
        description
        file {
          details {
            image {
              height
              width
            }
          }
          url
        }
      }
      subheader
      textAlignment
      cardTextColor: textColor
      cardTextPosition: textPosition
      title
      ctaLayout
      settings {
        ... on HeaderStyleSetting {
          id
          contentType
          title
          affectedHeader
          headerFont
          relativeToBrowserWidth
          headerLetterSpacing {
            mobile
            tablet
            desktop
          }
          headerLineHeight {
            mobile
            tablet
            desktop
          }
          headerSize {
            mobile
            tablet
            desktop
          }
          headerSpaceAfter {
            mobile
            tablet
            desktop
          }
          eyebrowLetterSpacing {
            mobile
            tablet
            desktop
          }
          eyebrowLineHeight {
            mobile
            tablet
            desktop
          }
          eyebrowSize {
            mobile
            tablet
            desktop
          }
          eyebrowSpaceAfter {
            mobile
            tablet
            desktop
          }
        }
        ... on BodyStyleSetting {
          id
          contentType
          title
          bodyFont
          relativeToBrowserWidth
          bodySize {
            mobile
            tablet
            desktop
          }
          bodyLineHeight {
            mobile
            tablet
            desktop
          }
          bodyLetterSpacing {
            mobile
            tablet
            desktop
          }
          bodySpaceAfter {
            mobile
            tablet
            desktop
          }
        }
      }
      headerMaxLineLength
      rowSpan {
        mobile
        tablet
        desktop
      }
      columnSpan {
        mobile
        tablet
        desktop
      }
      hoverEffect
    }
  }
`;

export default {};
